export function translate(field_name) {
  const traducciones = {
    history_id: "ID",
    id: "ID",
    number: "Numero",
    start_time: "Hora de inicio",
    end_time: "Hora de fin",
    shift_workers: "Número de Trabajadores",
    note: "Notas",
    process_status: "Status",
    process_room: "Sala",
    process_type: "Tipo de proceso",
    shift: "Turno",
    shift_supervisor: "Supervisor de turno",
    changes: "Cambios",
    client_customer: "Cliente",
    quantity: "Cantidad",
    net_kilograms: "KN",
    gross_kilograms: "KB",
    created_at: "Hora de creación (Sistema)",
    creation_date: "Fecha de creación",
    condition: "Condicion",
    status_content: "Status",
    string_specs: "Especificaciones",
    container: "Formato/Recipiente",
    lot: "Lote",
    origin: "Huerto",
    pallet: "Pallet",
    plant: "Planta",
    process: "Proceso",
    product_type: "Tipo de Producto",
    variety: "Variedad",
    waybill: "Guia de despacho de recepción",
    classification: "Clasificación",
    season: "Temporada",
    auto_number: "Número automático",
    approve: "Aprobado",
    is_complete: "Pallet completo",
    position: "Posición/Camara",
    dispatch_waybill: "Guía de despacho de salida",
    receipt_waybill: "Guía de despacho de recepción",
    dispatch_weight: "Peso en la salida",
    type: "Tipo",
    waybill_date: "Fecha de guía",
    arrival_datetime: "Hora de llegada",
    internal_note: "Nota interna",
    license_plate: "Patente",
    truck_driver: "Chofer",
    company: "Emisor de guía",
    recipient_company: "Receptor de guia",
    waybill_type: "Tipo de guía de despacho",
    waybill_status: "Status",
    custom_fields: "Información adicional"
  };

  return traducciones[field_name];
}
